import { agencyApi } from './agency.api';
import { CreateAgencyDto } from '@shared/common/agency/create-agency.dto';
import { IsUnique } from '@/modules/core/decorators/is-unique.decorator';

export class FrontCreateAgencyDto extends CreateAgencyDto {
    @IsUnique(async (text: string, originalText: string) => {
        const available = await agencyApi.isLabelAvailable(
            text,
          );

        return available || text === originalText;
    })
    public label!: string;

    @IsUnique(async (text: string, originalText: string) => {
        const available = await agencyApi.isCodeAvailable(
            text,
          );

        return available || text === originalText;
    })
    public code!: string;
}
